import { useCallback, useMemo } from 'react';
import useInfiniteFetch from '../useInfiniteFetch';
import useSubscribeStorage from '../../hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';
import { EXPANDED_ROWS_LIMIT } from 'src/constants/table';
import useQueryParams from '../../hooks/useQueryParams';
import { parseQueryToApiQuery } from 'src/utils/query.utils';
import CatalogInventoryService from '../../services/catalog-inventory.service';

const useGetCatalogInventoryNotConnectedDevices = ({ catalogInventoryId }) => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  const {
    queryObject: { searchValue: initialSearchValue, filters = {} },
  } = useQueryParams();

  const query = useMemo(
    () =>
      parseQueryToApiQuery({
        filters,
        searchValue: initialSearchValue,
      }),
    [filters, initialSearchValue],
  );

  const fetchFunction = useCallback(
    ({ page, limit }) =>
      CatalogInventoryService.getCatalogInventoryNotConnectedDevices({
        limit,
        page,
        catalogInventoryId,
        customerEnvId,
        query,
      }),
    [catalogInventoryId, customerEnvId, query],
  );

  const response = useInfiniteFetch({
    queryKey: ['catalogInventoryNotConnectedDevices', query, customerEnvId, catalogInventoryId],
    fetchFunction,
    expandedRowsLimit: EXPANDED_ROWS_LIMIT,
    itemName: 'affectedDevices',
  });

  return {
    ...response,
    query,
  };
};

export default useGetCatalogInventoryNotConnectedDevices;
